<template>
<div class="cw-content">
  <h1>{{ $t('where-do-i-vote') }}</h1>
  <div v-if="addressDetails.address">
    <div class="callout callout-info">
      <p class="lead">{{ $t('show-voting-location') }} <span class="font-weight-bold">{{ addressDetails.address }}</span></p>
      <p class="mb-1"><span class="font-weight-bold">{{ $t('ward') }}</span>{{ addressDetails.councilWard }}</p>
      <p class="mb-1"><span class="font-weight-bold">{{ $t('school-division') }}</span>{{ addressDetails.schoolDivision }}</p>
      <p v-if="addressDetails.schoolDivisionWard" class="mb-1"><span class="font-weight-bold">{{ $t('school-division-ward') }}</span>{{ addressDetails.schoolDivisionWard }}</p>
      <p v-if="nominated_period"><a href="#candidates">{{ $t('view-nominated-candidates')}}</a></p>
      <p v-else><a href="#candidates">{{ $t('view-registered-candidates')}}</a></p>
      <button @click="back" class="btn btn-outline-secondary mt-2 mb-3">{{ $t('find-different-address') }}</button>
    </div>

    <ElectionLocationList :electionLocations="electionDayPolls[0]" :showTitle="true" :voteAnywhereWarning="voteAnywhereWarning"></ElectionLocationList>

    <hr />
    <h2 v-if="advancePolls.length > 0">{{ $t('other-advance') }}</h2>

    <ElectionLocationType v-for="(electionLocations,index) in advancePolls" :key="index" :electionLocations="electionLocations" :index="index"></ElectionLocationType>
    
    <ShowCandidates :addressDetails="addressDetails" :nominated_period="nominated_period"></ShowCandidates>

  </div>
  <Spinner v-else></Spinner>

</div>
</template>

<script>
  import ElectionLocationType from '@/components/ElectionLocationType.vue';
  import ElectionLocationList from '@/components/ElectionLocationList.vue';
  import ShowCandidates from '@/components/ShowCandidates.vue';
  import Spinner from '@/components/Spinner.vue';
  import axios from 'axios';
  const POLL_TYPE_LIMIT = 3;

  export default {
    components: {
      ElectionLocationType,
      ElectionLocationList,
      ShowCandidates,
      Spinner,
    },

    data() {
      return {
        fetching: false,
        voting_data: null,
        nominated_period: (new Date() > new Date('2022-09-14T08:30:00')),
      }
    },

    created() {
      this.get_locations();
    },

    methods: {
      async get_locations() {
        let url = this.$APP_API_URL + '?action=where-do-i-vote&addressId=' + this.$route.params.address_id;
        this.fetching = true;
        const data = await axios.get(url);
        this.fetching = false;
        this.voting_data = data.data;
      },

      view_registered() {

      },

      view_nominated() {

      },

      back() {
        this.$router.push({name: 'WhereDoIVote'});
      },

      formatPolls(polls) {
        let types = {};
        polls.forEach(row => {
          if (types[row.pollType]) {
            types[row.pollType].push(row);
          } else {
            types[row.pollType] = [row];
          }
        })
        return Object.keys(types).map(key => {
          let limit = (key === 'CommunityAdvanceVotingLocation') ? 1 : POLL_TYPE_LIMIT;
          return {
              pollType: key,
              locations: types[key],
              limit: limit,
          };
        });
      }

    },

    computed: {

      addressDetails() {
        return (this.voting_data && this.voting_data.addressDetails) ? this.voting_data.addressDetails : {};
      },

      electionDayPolls() {
        return (this.voting_data && this.voting_data.electionDayPolls) ? this.formatPolls(this.voting_data.electionDayPolls) : [];
      },

      advancePolls() {
        return (this.voting_data && this.voting_data.advancePolls) ? this.formatPolls(this.voting_data.advancePolls) : [];
      },

      voteAnywhereWarning() {
        return (this.voting_data && this.voting_data.addressDetails
          && ['Waverley West', 'Old Kildonan', 'Transcona'].includes(this.voting_data.addressDetails.councilWard));
      },

      moreThanOneElectionDayLocation() {
        return (this.electionDayPolls.length && this.electionDayPolls[0].locations && this.electionDayPolls[0].locations.length > 1);
      }

    },
  }
</script>

<style>
</style>